import { Invite } from '@/api';
import { ReactElement, ReactNode } from 'react';
import { InvitesContext, InvitesContextData } from './context';

type InvitesProviderProps = {
    readonly invites: Invite[];
    readonly children?: ReactNode;
};

export function InvitesProvider({
    invites,
    children
}: InvitesProviderProps): ReactElement {
    const value: InvitesContextData = {
        invites
    };

    return (
        <InvitesContext.Provider value={value}>
            {children}
        </InvitesContext.Provider>
    );
}
